import { render, staticRenderFns } from "./ValidateInvoices.vue?vue&type=template&id=31791242&scoped=true"
import script from "./ValidateInvoices.vue?vue&type=script&lang=js"
export * from "./ValidateInvoices.vue?vue&type=script&lang=js"
import style0 from "./ValidateInvoices.vue?vue&type=style&index=0&id=31791242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31791242",
  null
  
)

export default component.exports